<template>
    <div class="a-switch" :class="{ 'a-switch--checked': localValue }">
        <label>
            <div class="a-switch__switch">
                <input
                    type="checkbox"
                    class="a-switch__checkbox"
                    v-model="localValue"
                    :disabled="disabled"
                />
                <span class="a-switch__slider"></span>
            </div>
            <span v-if="text">{{ text }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: false
        },
        checked: {
            type: Boolean,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localValue: {
            get() {
                return this.checked
            },
            set(val) {
                this.$emit('change', val)
            }
        }
    }
}
</script>
